@if (schedule().end) {
  {{ "publicationTemplate.schedule.scheduledFrom" | translate }}
  <span class="date">{{ schedule().start | date: dateTimeFormat() }}</span>
  {{ "publicationTemplate.schedule.scheduledTo" | translate }}
  <span class="date">{{ schedule().end | date: dateTimeFormat() }}</span>
} @else {
  {{ "publicationTemplate.schedule.scheduledFor" | translate }}
  <span class="date">{{ schedule().start | date: dateTimeFormat() }}</span>
}
